<template>
  <div id="filtroPedido">
    <b-row class="pt-3 pb-2" id="headerPagePed">
      <b-col sm="10 title" class="pl-0">{{title || "Título não informado"}}</b-col>
      <b-col sm="2" class="pr-0"><b-button  size="sm" variant="secondary" class="btn-plus left" v-on:click="adicionar" id="btnTeste"><i class="fas fa-plus"></i> Adicionar</b-button></b-col>
    </b-row>
    <b-row class="input-search filtro shadow p-2" id="filtroWeb">
      <b-col cols="4">
        <b-input-group>
          <b-input-group-prepend>
            <span class="input-group-text"><i class="fa fa-search"></i></span>
          </b-input-group-prepend>
          <b-form-input size="sm" :placeholder="placeholderNm" v-model="termo" autocomplete="off">
          </b-form-input>
        </b-input-group>
      </b-col>
      <b-col cols="2" class="p-0">
        <b-form-select size="sm" v-model="statusPedidoSelec" @change="onChangeSituacao($event)">
          <!--<template slot="first">-->
            <!--<option :value="null" disabled>&#45;&#45; Status &#45;&#45;</option>-->
          <!--</template>-->
          <option v-for="(item, key) in statusPedidos" :value="key" :key="item.codigo">
          {{item.descricao}}
        </option>
        </b-form-select>
      </b-col>
      <b-col cols="4">
        <div class="datepicker-container with-button">
          <div class="datepicker-trigger">
            <b-button id="datepicker-button-trigger" size="sm">
              {{ formatDates(buttonDateOne, buttonDateTwo) || 'Período' }}
            </b-button>
            <airbnb-style-datepicker
              :trigger-element-id="'datepicker-button-trigger'"
              :mode="'range'"
              :date-one="buttonDateOne"
              :date-two="buttonDateTwo"
              :min-date="'2018-02-28'"
              :fullscreen-mobile="true"
              :months-to-show="2"
              :offset-y="10"
              :trigger="trigger"
              v-on:date-one-selected="function(val) { buttonDateOne = val }"
              v-on:date-two-selected="function(val) { buttonDateTwo = val }"
              v-on:closed="onClosed"
              v-on:previous-month="onMonthChange"
              v-on:next-month="onMonthChange"
            ></airbnb-style-datepicker>
            <!--:startDate="this.firstDay"
              :endDate="this.lastDay"-->
          </div>
        </div>
      </b-col>
      <b-col cols="2" class="pl-0">
        <b-button class="btnLimpaFiltro" size="sm" v-on:click="limparFiltro()"><i class="fas fa-eraser"></i></b-button>
        <b-button class="btnBuscaFiltro" size="sm" v-on:click="filtrar()"><i class="fas fa-search"></i></b-button>
      </b-col>
    </b-row>
    <b-row class="input-search filtro shadow" id="filtroMob">
      <b-button id="abreModalFiltro" size="sm" v-on:click="abreModalFiltro()"><i class="fas fa-search mr-2"></i>Filtrar</b-button>
      <b-button class="ml-3 btnLimpaFiltro" size="sm" v-on:click="limparFiltro()"><i class="fas fa-eraser mr-2"></i>Limpar Filtro</b-button>
    </b-row>
    <b-modal
      v-model="modalFiltro"
      ok-title="Filtrar"
      ok-variant="primary"
      cancel-title="Cancelar"
      cancel-variant="secondary"
      @ok="filtrar"
      :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant">
      <template slot="modal-header">
        <h5>Filtrar Pedidos</h5>
      </template>
      <form>
        <div class="form-row m-0">
          <div class="w-100 mb-3">
            <b-input-group>
              <b-input-group-prepend class="mt-0">
                <span class="input-group-text"><i class="fa fa-search"></i></span>
              </b-input-group-prepend>
              <b-form-input size="sm" :placeholder="placeholderNm" v-model="termo">
              </b-form-input>
            </b-input-group>
          </div>
          <div class="w-100 mb-3">
            <b-form-select size="sm" v-model="statusPedidoSelec" @change="onChangeSituacao($event)">
              <option v-for="(item, key) in statusPedidos" :value="key" :key="item.codigo">
                {{item.descricao}}
              </option>
            </b-form-select>
          </div>



          <div class="w-100 mb-3">
            <div class="datepicker-container with-button">
              <div class="datepicker-trigger">
                <b-button id="datepicker-button-trigger-mobile" size="sm">
                  {{ formatDates(buttonDateOne, buttonDateTwo) || 'Período' }}
                </b-button>
                <airbnb-style-datepicker
                  :trigger-element-id="'datepicker-button-trigger-mobile'"
                  :mode="'range'"
                  :date-one="buttonDateOne"
                  :date-two="buttonDateTwo"
                  :min-date="'2018-02-28'"
                  :fullscreen-mobile="true"
                  :months-to-show="2"
                  :offset-y="10"
                  :trigger="trigger"
                  v-on:date-one-selected="function(val) { buttonDateOne = val }"
                  v-on:date-two-selected="function(val) { buttonDateTwo = val }"
                  v-on:closed="onClosed"
                  v-on:previous-month="onMonthChange"
                  v-on:next-month="onMonthChange"
                ></airbnb-style-datepicker>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
  import SelectVue from './SelectVue'
  import tablePedidos from '@/services/tablePedidos'
  import { broadcastServer } from '@/main'
// import format from 'date-fns/format'
  export default {
    data () {
      return {
        firstDay: '',
        lastDay: '',
        dateFormat: 'D MMM',
        inputDateOne: '',
        inputDateTwo: '',
        buttonDateOne: '',
        buttonDateTwo: '',
        inlineDateOne: '',
        sundayDateOne: '',
        sundayFirst: false,
        alignRight: false,
        trigger: false,
        termo: '',
        pedidos: [],
        statusPedido: null,
        codigo: '',
        key: '',
        codStatus: '',
        options: [],
        statusPedidos: [],
        statusPedidoSelec: 0,
        statusPedidoFiltrar: null,
        situacaoSelecionada: {},
        dataDe: '',
        dataAte: '',
        modalFiltro: false,
        headerTextVariant: 'light',
        headerBgVariant: 'dark',
        selected: null
      }
    },
    name: 'NewItemsVue',
    props: [
      'title',
      'placeholderNm'],
    components: {
      SelectVue
    },
    created () {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      this.buttonDateOne = firstDay.toJSON().slice(0, 10)
      this.buttonDateTwo = lastDay.toJSON().slice(0, 10)
      tablePedidos.listarSituacaoPedido().then(response => {
        this.statusPedidos = response.data.dados.sort(function (a, b) {
          return a.codigo - b.codigo
        })
      })
    },
    methods: {
      onChangeSituacao (index) {
        let statusSelec = index
        // this.git  = statusSelec.codigo
        console.log('dssdf' + statusSelec)
      },
      adicionar: function () {
        broadcastServer.$emit('adicionarPedido', '')
        broadcastServer.$emit('esconderBotaoAdicionarCliente', '')
      },
      onChange (index) {
        this.statusSelecionado = this.options[index]
        this.codStatus = this.statusSelecionado.codigo
        // console.log(this.codStatus)
      },
      filtrar: function () {
        let objectPost = {termo: this.termo, codStatus: this.statusPedidoSelec, emissaoDe: this.dataDe, emissaoAte: this.dataAte}
        broadcastServer.$emit('filtrosSelecionados', objectPost, 0)
      },
      formatDates: function (dateOne, dateTwo) {
        let formattedDates = ''
        if (dateOne) {
          this.dataDe = dateOne
          let dataFormatada = dateOne.substring(8, 10) + '/' + dateOne.substring(5, 7) + '/' + dateOne.substring(0, 4)
          // console.log(dataFormatada)
          formattedDates = dataFormatada // dateFns.format(dateOne, this.dateFormat)
        }
        if (dateTwo) {
          this.dataAte = dateTwo
          let dataFormatada = dateTwo.substring(8, 10) + '/' + dateTwo.substring(5, 7) + '/' + dateTwo.substring(0, 4)
          formattedDates += ' - ' + dataFormatada // dateFns.format(dateTwo, this.dateFormat)
        }
        return formattedDates
      },
      onClosed: function () {
        let datesStr = this.formatDates(this.inputDateOne, this.inputDateTwo)
        console.log('Dates Selected: ' + datesStr)
        this.trigger = false
      },
      onMonthChange: function (dates) {
        console.log('months changed', dates)
      },
      limparFiltro: function () {
        this.termo = ''
        this.statusPedido = null
        this.dataDe = ''
        this.dataAte = ''
        this.inputDateOne = ''
        this.inputDateTwo = ''
        this.buttonDateOne = ''
        this.buttonDateTwo = ''
        let objectPost = {termo: '', codStatus: 0, emissaoDe: '', emissaoAte: ''}
        broadcastServer.$emit('filtrosSelecionados', objectPost, 1)
      },
      abreModalFiltro: function () {
        this.modalFiltro = true
      }
    }
  }
</script>
<style scoped>
  .title {
    font-weight: 600;
    text-align: left;
    font-family: 'Didact Gothic', sans-serif;
  }
  .filtro{
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/NewItemsVue.vue